import { useLocale } from 'next-intl';

export const localeMap = {
  en: 'en_US',
  no: 'nb_NO',
  sv: 'sv_SE',
  de: 'de_DE',
  pl: 'pl_PL',
  fi: 'fi_FI',
};

const localeLowercaseMap = {
  en: 'en_us',
  no: 'nb_no',
  sv: 'sv_se',
  de: 'de_de',
  pl: 'pl_pl',
  fi: 'fi_fi',
};

export default function useLocaleSuffix() {
  const defaultLocale = useLocale();
  return (
    name: string = '',
    uppercase: boolean = true,
    locale: string = defaultLocale
  ): string => {
    let underscore = name ? '_' : '';
    if (uppercase) {
      return `${name}${underscore}${
        localeMap[locale as keyof typeof localeMap]
      }`;
    } else {
      return `${name}${underscore}${
        localeLowercaseMap[locale as keyof typeof localeLowercaseMap]
      }`;
    }
  };
}
